module.exports = __webpack_public_path__ + "img/1099one5.f534c225.png";